import { useMemo } from "react";

// Lendmarq-side default. The vendored components only ever read the two map
// keys off this hook — lendmarq-los's own src/hooks/useEnv is the one that
// drives partner branding across the rest of the app.
const PARTNER_CONFIG = {
  default: {
    displayName: "Lendmarq",
    logoUrl: null,
    logoFormatType: "text",
    primaryColor: "#1F5AF2",
  },
};

export const useEnv = () => {
  return useMemo(() => {
    const partnerName = process.env.REACT_APP_PARTNER_NAME || "default";
    const config = PARTNER_CONFIG[partnerName] || PARTNER_CONFIG.default;

    return {
      partnerName,
      isPartnerDefault: partnerName === "default",
      displayName: config.displayName,
      logoUrl: config.logoUrl,
      logoFormatType: config.logoFormatType,
      primaryColor:
        process.env.REACT_APP_PARTNER_PRIMARY_COLOR || config.primaryColor,
      backendBaseUrl: process.env.REACT_APP_BACKEND_BASE_URL || "",
      googleMapsKey: process.env.REACT_APP_GOOGLE_MAPS_KEY || "",
      azureMapsKey: process.env.REACT_APP_AZURE_MAPS_KEY || "",
    };
  }, []);
};

export default useEnv;
